module.exports = __webpack_public_path__ + "static/income-92a3a1e32cca6f0e2e5b5bcda70ef94c.svg";